import { Pipe, PipeTransform } from '@angular/core';
import { formatSadmEntityName, SadmEntity, SadmType } from '@pixacare/domain';

@Pipe({
  name: 'sadmEntityName',
  pure: true,
  standalone: true,
})
export class SadmEntityNamePipe implements PipeTransform {
  transform(value: Pick<SadmEntity, 'name' | 'patientEntityIndex'>, sadmType?: SadmType, index?: number): string {
    return formatSadmEntityName(value as SadmEntity, sadmType, index);
  }
}
